import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { ApiClient } from '@/services/api-client';

const QUERY_KEY = ['organization.manualReplyPreference'];

/**
 * Org-level preference: when enabled, replying manually to a conversation no
 * longer switches the AI agent off for that conversation.
 */
export function useManualReplyPreference() {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => ApiClient.organization.getManualReplyPreference(),
    staleTime: 60_000,
    select: (res) => res.data?.KeepAgentOnManualReply ?? false,
  });
}

export function useUpdateManualReplyPreference() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (keepAgentOnManualReply: boolean) =>
      ApiClient.organization.updateManualReplyPreference(keepAgentOnManualReply),
    onSuccess: (res) => {
      queryClient.setQueryData(QUERY_KEY, res);
    },
  });
}
